import ReactPaginate from "react-paginate";

import styles from "./index.module.scss";

//TODO: 型定義は後で修正
type Props = {
  data: any;
  onPageChange: (selectedItem: { selected: number }) => void;
  filterList: any;
  pp: number;
};

const Pagination: React.FC<Props> = ({
  data,
  onPageChange,
  filterList,
  pp
}) => {
  return (
    <ReactPaginate
      forcePage={filterList.page - 1}
      pageCount={Math.ceil(data.page.total / pp)}
      onPageChange={onPageChange}
      marginPagesDisplayed={1}
      pageRangeDisplayed={2}
      containerClassName={styles.paginate_inner}
      pageClassName={styles.paginate_item}
      pageLinkClassName={styles.paginate_link}
      activeClassName={styles.paginate_item_active}
      previousClassName={styles.paginate_item_arrow}
      nextClassName={styles.paginate_item_arrow}
      previousLinkClassName={styles.paginate_link_left}
      nextLinkClassName={styles.paginate_link_right}
      breakLinkClassName={styles.paginate_link}
      previousLabel=""
      nextLabel=""
      breakLabel="・・・"
    />
  );
};

export default Pagination;
